import { IApplicationState } from '../../types/redux';

export function selectUser(state: IApplicationState) {
  return state.user;
}
